import type { ComboTier } from "../content/combo";
import { useReducedMotion } from "../hooks/useReducedMotion";
import "./Burst.css";

interface Props {
  /** The tier just reached: how many sparkles, and whether the card flashes. */
  tier: ComboTier;
  /** The colour of the rank in play, for the top tier. */
  rankColour?: string | undefined;
}

/**
 * A burst of four-point sparkles out from the centre of whatever it sits
 * over (the question card), with a flash at the top tier. Pure CSS, never
 * catches a tap, and nothing at all under reduced motion. Re-key it to
 * fire again.
 */
export function Burst({ tier, rankColour = "var(--gold)" }: Props) {
  const reduced = useReducedMotion();
  if (reduced || (tier.sparkles === 0 && !tier.flash)) return null;
  const colour = tier.colour === "rank" ? rankColour : tier.colour;
  const n = tier.sparkles;
  return (
    <div className="burst" style={{ "--c": colour } as React.CSSProperties} aria-hidden="true">
      {tier.flash && <div className="burst-flash" />}
      {Array.from({ length: n }, (_, i) => (
        <i
          key={i}
          className="sparkle"
          style={
            {
              "--a": `${Math.round((360 / n) * i + (i % 2) * 11)}deg`,
              "--d": i % 3 === 0 ? 0.65 : i % 3 === 1 ? 0.85 : 1,
              animationDelay: `${(i % 4) * 40}ms`,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
}
